import React from 'react';
import { TextareaElement as TextareaType } from '../../types/element.types';

interface TextareaElementProps {
  element: TextareaType;
}

/**
 * Textarea Element Renderer
 */
const TextareaElement: React.FC<TextareaElementProps> = ({ element }) => {
  const { label, placeholder, rows, required, name } = element.settings || {};

  return (
    <div className="textarea-element-wrapper">
      {label && (
        <label className="block text-sm font-medium mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        placeholder={placeholder}
        rows={rows || 4}
        required={required}
        name={name}
        className="textarea-element"
        style={element.styles as React.CSSProperties}
      />
    </div>
  );
};

export default TextareaElement;

